import type { CSSProperties } from 'react';

export const SCORECARDS_DATA_ATTR = 'data-scorecards-payload';

export interface ScorecardHistoryRow {
  reviewer: string;
  rating: string;
  activity: string;
  scorecard_url: string | null;
}

// Shape of a scorecard as produced by `extractScorecards` (the recruiter-side
// composer feeds these into the tiptap node) — only the fields we read here
// are typed; the upstream object carries more keys we don't need.
export interface RawScorecard {
  id?: number | string;
  reviewer?: { name?: string | null } | null;
  rating?: string | null;
  ats_job_stage_action?: { name?: string | null } | null;
  scorecard_url?: string | null;
}

export const tableScrollStyle: CSSProperties = {
  overflowX: 'auto',
  maxWidth: '100%',
  marginTop: '8px',
  marginBottom: '8px',
};

export const tableCardStyle: CSSProperties = {
  display: 'inline-block',
  verticalAlign: 'top',
  // min-width keeps all 4 headers on one line; narrower viewports scroll.
  minWidth: '720px',
  boxSizing: 'border-box',
  border: '1px solid #E9EBF4',
  borderRadius: '4px',
};

export const tableCardHeaderStyle: CSSProperties = {
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontWeight: 550,
  color: '#413B74',
  backgroundColor: '#F8F9FC',
  padding: '10px 12px',
};

export const tableBaseStyle: CSSProperties = {
  borderCollapse: 'collapse',
  width: '100%',
};

const thTdStyle: CSSProperties = {
  border: '1px solid #E9EBF4',
  padding: '10px',
  textAlign: 'left',
  fontSize: '14px',
  overflowWrap: 'anywhere',
};

const thStyle: CSSProperties = {
  ...thTdStyle,
  color: '#413B74',
  fontWeight: 550,
  whiteSpace: 'nowrap',
};

// Inner cell borders are dropped at the table edges so they don't double up
// with the outer card border.
export const getCellStyle = (
  isFirstColumn: boolean,
  isLastColumn: boolean,
  isLastRow = false
): CSSProperties => ({
  ...thTdStyle,
  borderLeft: isFirstColumn ? 'none' : '1px solid #E9EBF4',
  borderRight: isLastColumn ? 'none' : '1px solid #E9EBF4',
  borderBottom: isLastRow ? 'none' : '1px solid #E9EBF4',
});

export const getHeaderStyle = (
  isFirstColumn: boolean,
  isLastColumn: boolean
): CSSProperties => ({
  ...thStyle,
  borderLeft: isFirstColumn ? 'none' : '1px solid #E9EBF4',
  borderRight: isLastColumn ? 'none' : '1px solid #E9EBF4',
});

export const formatRating = (rating?: string | null): string =>
  rating
    ? rating.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
    : '-';
